import * as actionType from './actionType';

export const areUserPreferenceFetched = (isFetched) => ({
  type: actionType.ARE_USER_PREFERENCE_FETCHED,
  payload: isFetched
});

export const hasPreferenceUpdated = (newNumber) => ({
  type: actionType.USER_PREFERENCE_UPDATED,
  payload: newNumber
});

export const updateCategoryId = (cCode) => ({
  type: actionType.UPDATE_CATEGORY,
  payload: cCode
});

export const activeIndex = (payload) => ({
  type: actionType.ACTIVE_INDEX,
  payload,
});

export const deleteProfileImage = () => ({
  type: actionType.DELETE_PROFILE_IMAGE,
});


export const isToken = (data) => ({
  type: actionType.TOKEN,
  payload: data,
});

export const isTrialMode = (data) => ({
  type: actionType.TRIAL_MODE,
  payload: data,
});

export const setUserLocation = ({ latitude, longitude, timestamp }) => ({
  type: actionType.SET_USER_LOCATION,
  payload: {
    latitude,
    longitude,
    timestamp
  }
});

export const showAuthModal = (bool) => ({
  type: actionType.AUTH_MODAL,
  payload: bool,
});

export const signOut = () => ({
  type: actionType.SIGN_OUT,
});

export const updateProfileImage = (data) => ({
  type: actionType.UPDATE_PROFILE_IMAGE,
  payload: data,
});

export const updateUsrDetails = (data) => ({
  type: actionType.UPDATE_USER_DETAILS,
  payload: data,
});

export const updateUserPreferenceBudgetRange = (minValue, maxValue) => ({
  type: actionType.UPDATE_USER_PREFERENCE_BUDGET,
  payload: { budget: [minValue, maxValue] }
});

export const updateUserPreferenceFocusArea = (value) => ({
  type: actionType.UPDATE_USER_PREFERENCE_FOCUS_AREA,
  payload: { focusArea: value }
});

export const updateUserPreference = (preference) => ({
  type: actionType.UPDATE_USER_PREFERENCE,
  payload: preference
});

export const updateUserPreferenceReleasedWithin = (value) => ({
  type: actionType.UPDATE_USER_PREFERENCE_RELEASED_WITHIN,
  payload: { releasedWithin: parseInt(value) }
});

export const userDetails = (data) => ({
  type: actionType.USER_DETAILS,
  payload: data,
});